import { HttpMethod, RequestOptions, useUserRequest } from "../common/lib/fetch";

const useRemoveKiosk = (siteId: string, kioskId: string, options: RequestOptions) =>
  useUserRequest({
    path: `/api/sites/${siteId}/kiosks/${kioskId}`,
    method: HttpMethod.DELETE
  }, options);

export default useRemoveKiosk;